/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 16:58:02
 * @Description: 二次认证 index
 */
import SecondAuth from "./secondAuth";
export { SecondAuth };
